// Utilitaires pour les URLs d’uploads : same-origin in prod (nginx serves /uploads)
import { BASE_URL } from '../constants';

export const getImageUrl = (imagePath) => {
  if (!imagePath) return '/images/placeholder.jpg';

  if (imagePath.startsWith('http')) return imagePath;

  const base = BASE_URL || '';
  let normalized = String(imagePath).replace(/\\/g, '/');

  if (normalized.startsWith('/images/')) {
    return normalized;
  }

  normalized = normalized.replace(/^\/+/, '');
  // Fix legacy bad paths like uploads/uploads/file.jpg
  normalized = normalized.replace(/^(uploads\/)+/, '');

  return `${base}/uploads/${normalized}`;
};

export const getUploadUrl = () => `${BASE_URL || ''}/api/upload`;
